export function setAttr(bool: boolean | undefined) {
  if (!bool) return undefined;
  return true;
}
